import { Action } from '@ngrx/store';
import { Moment } from 'moment';
import { ISalesDocument } from '@cemex-core/cmx-api/models/product/models/sales-document.interface';

export const SET_MASTER_CONTRACT = '[MasterContract] Select contract';
export const SET_MASTER_CONTRACT_DATE = '[MasterContract] Select date';

export class SelectMasterContractAction implements Action {
  readonly type = SET_MASTER_CONTRACT;

  constructor(public payload: ISalesDocument | null) {}
}

export class SelectMasterContractDateAction implements Action {
  readonly type = SET_MASTER_CONTRACT_DATE;

  constructor(public payload: { date: Date; time: Moment } | null) {}
}

export type SelectedContractActions = SelectMasterContractAction | SelectMasterContractDateAction;
